// AUTO-GENERATED FILE - DO NOT EDIT
// Run `bun run genTeeth` instead.
/* istanbul ignore file */
/* eslint-disable */
import ToothModelHollowHingedEmbossedNoneGingiva from '@/assets/tooth-models/hollow-hinged-embossed-none-gingiva.svg';
import ToothModelHollowHingedEmbossedNoneNone from '@/assets/tooth-models/hollow-hinged-embossed-none-none.svg';
import ToothModelHollowHingedEmbossedPalateGingiva from '@/assets/tooth-models/hollow-hinged-embossed-palate-gingiva.svg';
import ToothModelHollowHingedEmbossedPalateNone from '@/assets/tooth-models/hollow-hinged-embossed-palate-none.svg';
import ToothModelHollowHingedEngravedNoneGingiva from '@/assets/tooth-models/hollow-hinged-engraved-none-gingiva.svg';
import ToothModelHollowHingedEngravedNoneNone from '@/assets/tooth-models/hollow-hinged-engraved-none-none.svg';
import ToothModelHollowHingedEngravedPalateGingiva from '@/assets/tooth-models/hollow-hinged-engraved-palate-gingiva.svg';
import ToothModelHollowHingedEngravedPalateNone from '@/assets/tooth-models/hollow-hinged-engraved-palate-none.svg';
import ToothModelHollowHingedNoneNoneGingiva from '@/assets/tooth-models/hollow-hinged-none-none-gingiva.svg';
import ToothModelHollowHingedNoneNoneNone from '@/assets/tooth-models/hollow-hinged-none-none-none.svg';
import ToothModelHollowHingedNonePalateGingiva from '@/assets/tooth-models/hollow-hinged-none-palate-gingiva.svg';
import ToothModelHollowHingedNonePalateNone from '@/assets/tooth-models/hollow-hinged-none-palate-none.svg';
import ToothModelHollowNoneEmbossedNoneGingiva from '@/assets/tooth-models/hollow-none-embossed-none-gingiva.svg';
import ToothModelHollowNoneEmbossedNoneNone from '@/assets/tooth-models/hollow-none-embossed-none-none.svg';
import ToothModelHollowNoneEmbossedPalateGingiva from '@/assets/tooth-models/hollow-none-embossed-palate-gingiva.svg';
import ToothModelHollowNoneEmbossedPalateNone from '@/assets/tooth-models/hollow-none-embossed-palate-none.svg';
import ToothModelHollowNoneEngravedNoneGingiva from '@/assets/tooth-models/hollow-none-engraved-none-gingiva.svg';
import ToothModelHollowNoneEngravedNoneNone from '@/assets/tooth-models/hollow-none-engraved-none-none.svg';
import ToothModelHollowNoneEngravedPalateGingiva from '@/assets/tooth-models/hollow-none-engraved-palate-gingiva.svg';
import ToothModelHollowNoneEngravedPalateNone from '@/assets/tooth-models/hollow-none-engraved-palate-none.svg';
import ToothModelHollowNoneNoneNoneGingiva from '@/assets/tooth-models/hollow-none-none-none-gingiva.svg';
import ToothModelHollowNoneNoneNoneNone from '@/assets/tooth-models/hollow-none-none-none-none.svg';
import ToothModelHollowNoneNonePalateGingiva from '@/assets/tooth-models/hollow-none-none-palate-gingiva.svg';
import ToothModelHollowNoneNonePalateNone from '@/assets/tooth-models/hollow-none-none-palate-none.svg';
import ToothModelHollowPillarsEmbossedNoneGingiva from '@/assets/tooth-models/hollow-pillars-embossed-none-gingiva.svg';
import ToothModelHollowPillarsEmbossedNoneNone from '@/assets/tooth-models/hollow-pillars-embossed-none-none.svg';
import ToothModelHollowPillarsEmbossedPalateGingiva from '@/assets/tooth-models/hollow-pillars-embossed-palate-gingiva.svg';
import ToothModelHollowPillarsEmbossedPalateNone from '@/assets/tooth-models/hollow-pillars-embossed-palate-none.svg';
import ToothModelHollowPillarsEngravedNoneGingiva from '@/assets/tooth-models/hollow-pillars-engraved-none-gingiva.svg';
import ToothModelHollowPillarsEngravedNoneNone from '@/assets/tooth-models/hollow-pillars-engraved-none-none.svg';
import ToothModelHollowPillarsEngravedPalateGingiva from '@/assets/tooth-models/hollow-pillars-engraved-palate-gingiva.svg';
import ToothModelHollowPillarsEngravedPalateNone from '@/assets/tooth-models/hollow-pillars-engraved-palate-none.svg';
import ToothModelHollowPillarsNoneNoneGingiva from '@/assets/tooth-models/hollow-pillars-none-none-gingiva.svg';
import ToothModelHollowPillarsNoneNoneNone from '@/assets/tooth-models/hollow-pillars-none-none-none.svg';
import ToothModelHollowPillarsNonePalateGingiva from '@/assets/tooth-models/hollow-pillars-none-palate-gingiva.svg';
import ToothModelHollowPillarsNonePalateNone from '@/assets/tooth-models/hollow-pillars-none-palate-none.svg';
import ToothModelSolidHingedEmbossedNoneGingiva from '@/assets/tooth-models/solid-hinged-embossed-none-gingiva.svg';
import ToothModelSolidHingedEmbossedNoneNone from '@/assets/tooth-models/solid-hinged-embossed-none-none.svg';
import ToothModelSolidHingedEmbossedPalateGingiva from '@/assets/tooth-models/solid-hinged-embossed-palate-gingiva.svg';
import ToothModelSolidHingedEmbossedPalateNone from '@/assets/tooth-models/solid-hinged-embossed-palate-none.svg';
import ToothModelSolidHingedEngravedNoneGingiva from '@/assets/tooth-models/solid-hinged-engraved-none-gingiva.svg';
import ToothModelSolidHingedEngravedNoneNone from '@/assets/tooth-models/solid-hinged-engraved-none-none.svg';
import ToothModelSolidHingedEngravedPalateGingiva from '@/assets/tooth-models/solid-hinged-engraved-palate-gingiva.svg';
import ToothModelSolidHingedEngravedPalateNone from '@/assets/tooth-models/solid-hinged-engraved-palate-none.svg';
import ToothModelSolidHingedNoneNoneGingiva from '@/assets/tooth-models/solid-hinged-none-none-gingiva.svg';
import ToothModelSolidHingedNoneNoneNone from '@/assets/tooth-models/solid-hinged-none-none-none.svg';
import ToothModelSolidHingedNonePalateGingiva from '@/assets/tooth-models/solid-hinged-none-palate-gingiva.svg';
import ToothModelSolidHingedNonePalateNone from '@/assets/tooth-models/solid-hinged-none-palate-none.svg';
import ToothModelSolidNoneEmbossedNoneGingiva from '@/assets/tooth-models/solid-none-embossed-none-gingiva.svg';
import ToothModelSolidNoneEmbossedNoneNone from '@/assets/tooth-models/solid-none-embossed-none-none.svg';
import ToothModelSolidNoneEmbossedPalateGingiva from '@/assets/tooth-models/solid-none-embossed-palate-gingiva.svg';
import ToothModelSolidNoneEmbossedPalateNone from '@/assets/tooth-models/solid-none-embossed-palate-none.svg';
import ToothModelSolidNoneEngravedNoneGingiva from '@/assets/tooth-models/solid-none-engraved-none-gingiva.svg';
import ToothModelSolidNoneEngravedNoneNone from '@/assets/tooth-models/solid-none-engraved-none-none.svg';
import ToothModelSolidNoneEngravedPalateGingiva from '@/assets/tooth-models/solid-none-engraved-palate-gingiva.svg';
import ToothModelSolidNoneEngravedPalateNone from '@/assets/tooth-models/solid-none-engraved-palate-none.svg';
import ToothModelSolidNoneNoneNoneGingiva from '@/assets/tooth-models/solid-none-none-none-gingiva.svg';
import ToothModelSolidNoneNoneNoneNone from '@/assets/tooth-models/solid-none-none-none-none.svg';
import ToothModelSolidNoneNonePalateGingiva from '@/assets/tooth-models/solid-none-none-palate-gingiva.svg';
import ToothModelSolidNoneNonePalateNone from '@/assets/tooth-models/solid-none-none-palate-none.svg';
import ToothModelSolidPillarsEmbossedNoneGingiva from '@/assets/tooth-models/solid-pillars-embossed-none-gingiva.svg';
import ToothModelSolidPillarsEmbossedNoneNone from '@/assets/tooth-models/solid-pillars-embossed-none-none.svg';
import ToothModelSolidPillarsEmbossedPalateGingiva from '@/assets/tooth-models/solid-pillars-embossed-palate-gingiva.svg';
import ToothModelSolidPillarsEmbossedPalateNone from '@/assets/tooth-models/solid-pillars-embossed-palate-none.svg';
import ToothModelSolidPillarsEngravedNoneGingiva from '@/assets/tooth-models/solid-pillars-engraved-none-gingiva.svg';
import ToothModelSolidPillarsEngravedNoneNone from '@/assets/tooth-models/solid-pillars-engraved-none-none.svg';
import ToothModelSolidPillarsEngravedPalateGingiva from '@/assets/tooth-models/solid-pillars-engraved-palate-gingiva.svg';
import ToothModelSolidPillarsEngravedPalateNone from '@/assets/tooth-models/solid-pillars-engraved-palate-none.svg';
import ToothModelSolidPillarsNoneNoneGingiva from '@/assets/tooth-models/solid-pillars-none-none-gingiva.svg';
import ToothModelSolidPillarsNoneNoneNone from '@/assets/tooth-models/solid-pillars-none-none-none.svg';
import ToothModelSolidPillarsNonePalateGingiva from '@/assets/tooth-models/solid-pillars-none-palate-gingiva.svg';
import ToothModelSolidPillarsNonePalateNone from '@/assets/tooth-models/solid-pillars-none-palate-none.svg';

export const ToothModelHollowHingedEmbossedNoneGingivaSVG = ToothModelHollowHingedEmbossedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEmbossedNoneNoneSVG = ToothModelHollowHingedEmbossedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEmbossedPalateGingivaSVG = ToothModelHollowHingedEmbossedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEmbossedPalateNoneSVG = ToothModelHollowHingedEmbossedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEngravedNoneGingivaSVG = ToothModelHollowHingedEngravedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEngravedNoneNoneSVG = ToothModelHollowHingedEngravedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEngravedPalateGingivaSVG = ToothModelHollowHingedEngravedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedEngravedPalateNoneSVG = ToothModelHollowHingedEngravedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedNoneNoneGingivaSVG = ToothModelHollowHingedNoneNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedNoneNoneNoneSVG = ToothModelHollowHingedNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedNonePalateGingivaSVG = ToothModelHollowHingedNonePalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowHingedNonePalateNoneSVG = ToothModelHollowHingedNonePalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEmbossedNoneGingivaSVG = ToothModelHollowNoneEmbossedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEmbossedNoneNoneSVG = ToothModelHollowNoneEmbossedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEmbossedPalateGingivaSVG = ToothModelHollowNoneEmbossedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEmbossedPalateNoneSVG = ToothModelHollowNoneEmbossedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEngravedNoneGingivaSVG = ToothModelHollowNoneEngravedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEngravedNoneNoneSVG = ToothModelHollowNoneEngravedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEngravedPalateGingivaSVG = ToothModelHollowNoneEngravedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneEngravedPalateNoneSVG = ToothModelHollowNoneEngravedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneNoneNoneGingivaSVG = ToothModelHollowNoneNoneNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneNoneNoneNoneSVG = ToothModelHollowNoneNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneNonePalateGingivaSVG = ToothModelHollowNoneNonePalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowNoneNonePalateNoneSVG = ToothModelHollowNoneNonePalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEmbossedNoneGingivaSVG = ToothModelHollowPillarsEmbossedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEmbossedNoneNoneSVG = ToothModelHollowPillarsEmbossedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEmbossedPalateGingivaSVG = ToothModelHollowPillarsEmbossedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEmbossedPalateNoneSVG = ToothModelHollowPillarsEmbossedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEngravedNoneGingivaSVG = ToothModelHollowPillarsEngravedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEngravedNoneNoneSVG = ToothModelHollowPillarsEngravedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEngravedPalateGingivaSVG = ToothModelHollowPillarsEngravedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsEngravedPalateNoneSVG = ToothModelHollowPillarsEngravedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsNoneNoneGingivaSVG = ToothModelHollowPillarsNoneNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsNoneNoneNoneSVG = ToothModelHollowPillarsNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsNonePalateGingivaSVG = ToothModelHollowPillarsNonePalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelHollowPillarsNonePalateNoneSVG = ToothModelHollowPillarsNonePalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEmbossedNoneGingivaSVG = ToothModelSolidHingedEmbossedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEmbossedNoneNoneSVG = ToothModelSolidHingedEmbossedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEmbossedPalateGingivaSVG = ToothModelSolidHingedEmbossedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEmbossedPalateNoneSVG = ToothModelSolidHingedEmbossedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEngravedNoneGingivaSVG = ToothModelSolidHingedEngravedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEngravedNoneNoneSVG = ToothModelSolidHingedEngravedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEngravedPalateGingivaSVG = ToothModelSolidHingedEngravedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedEngravedPalateNoneSVG = ToothModelSolidHingedEngravedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedNoneNoneGingivaSVG = ToothModelSolidHingedNoneNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedNoneNoneNoneSVG = ToothModelSolidHingedNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedNonePalateGingivaSVG = ToothModelSolidHingedNonePalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidHingedNonePalateNoneSVG = ToothModelSolidHingedNonePalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEmbossedNoneGingivaSVG = ToothModelSolidNoneEmbossedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEmbossedNoneNoneSVG = ToothModelSolidNoneEmbossedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEmbossedPalateGingivaSVG = ToothModelSolidNoneEmbossedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEmbossedPalateNoneSVG = ToothModelSolidNoneEmbossedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEngravedNoneGingivaSVG = ToothModelSolidNoneEngravedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEngravedNoneNoneSVG = ToothModelSolidNoneEngravedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEngravedPalateGingivaSVG = ToothModelSolidNoneEngravedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneEngravedPalateNoneSVG = ToothModelSolidNoneEngravedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneNoneNoneGingivaSVG = ToothModelSolidNoneNoneNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneNoneNoneNoneSVG = ToothModelSolidNoneNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneNonePalateGingivaSVG = ToothModelSolidNoneNonePalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidNoneNonePalateNoneSVG = ToothModelSolidNoneNonePalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEmbossedNoneGingivaSVG = ToothModelSolidPillarsEmbossedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEmbossedNoneNoneSVG = ToothModelSolidPillarsEmbossedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEmbossedPalateGingivaSVG = ToothModelSolidPillarsEmbossedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEmbossedPalateNoneSVG = ToothModelSolidPillarsEmbossedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEngravedNoneGingivaSVG = ToothModelSolidPillarsEngravedNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEngravedNoneNoneSVG = ToothModelSolidPillarsEngravedNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEngravedPalateGingivaSVG = ToothModelSolidPillarsEngravedPalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsEngravedPalateNoneSVG = ToothModelSolidPillarsEngravedPalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsNoneNoneGingivaSVG = ToothModelSolidPillarsNoneNoneGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsNoneNoneNoneSVG = ToothModelSolidPillarsNoneNoneNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsNonePalateGingivaSVG = ToothModelSolidPillarsNonePalateGingiva as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
export const ToothModelSolidPillarsNonePalateNoneSVG = ToothModelSolidPillarsNonePalateNone as any as React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;
